var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["loyalty/templates/loyalty-birthday-day.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"g-loyalty-form__field-birthday-date\">\n\n    <div class=\"c-form__field ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"first")?"is-required":""), env.opts.autoescape);
output += " ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"loyaltyForm")?(lineno = 2, colno = 70, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "hasErrors"), "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"loyaltyForm")),"errors")),"messages")),"dateOfBirthDay")])):""), env.opts.autoescape);
output += " c-loyalty__birthday-field\">\n\n        <label for=\"loyalty-birthday-day\" class=\"u-off-screen-hidden\">\n            ";
output += runtime.suppressValue((lineno = 5, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_birthday-label-day"])), env.opts.autoescape);
output += "\n        </label>\n\n        <select ";
output += runtime.suppressValue((lineno = 8, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "validatedSelect"), "validatedSelect", context, ["ERROR_CORE_REQUIRED_FIELD_ERROR",runtime.makeKeywordArgs({"field": (lineno = 8, colno = 78, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.loyaltyForm.errors.messages.dateOfBirthDay"]))})])), env.opts.autoescape);
output += "\n            id=\"loyalty-birthday-day\"\n            name=\"dateOfBirthDay\"\n            class=\"c-form__select c-loyalty__birthday-select\"\n            data-qa-loyalty-signup-birthday-day\n            aria-describedby=\"loyalty-birthday-day_error\">\n\n            <option value=\"\" selected>\n                ";
output += runtime.suppressValue((lineno = 16, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["loyalty_day-option"])), env.opts.autoescape);
output += ":\n            </option>\n\n            ";
var t_1;
t_1 = 31;
frame.set("defaultDaysInMonth", t_1, true);
if(frame.topLevel) {
context.setVariable("defaultDaysInMonth", t_1);
}
if(frame.topLevel) {
context.addExport("defaultDaysInMonth", t_1);
}
output += "\n            ";
output += runtime.suppressValue((lineno = 20, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "dayOptions"), "dayOptions", context, [env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"loyaltyForm")),"data")),"birthdayData")),"birthDay")),env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"loyaltyForm")),"data")),"birthdayData")),"daysInMonth"),runtime.contextOrFrameLookup(context, frame, "defaultDaysInMonth"))])), env.opts.autoescape);
output += "\n\n        </select>\n\n            ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"loyaltyForm")?(lineno = 24, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "displayFieldErrors"), "displayFieldErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"loyaltyForm")),"errors")),"messages")),"dateOfBirthDay"),runtime.makeKeywordArgs({"id": "loyalty-birthday-day"})])):""), env.opts.autoescape);
output += "\n\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["loyalty/templates/loyalty-birthday-day.j2"] , dependencies)